import React from "react";
import { HStack, IconButton, Text } from "@chakra-ui/react";
import { FiLogOut } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { ArawaksLogo } from "../../components/utils/ArawaksLogo";
import { logOut } from "lib/auth";

export default function TopbarPerfil() {
  const navigate = useNavigate();
  const logout = async () => {
    await logOut();
    navigate("/registro", { replace: true });
  };

  return <HStack
    as="header" display={{ base: "flex", lg: "none" }} h="68px" px={{ base: "5", md: "6" }} bg="public.bg.panel/92" backdropFilter="blur(12px)"
    borderBottomWidth="1px" borderColor="public.border.subtle" justify="space-between"
    position="sticky" top="0" zIndex="10"
  >
    <HStack asChild gap="3"><Link to="/perfil">
      <ArawaksLogo alt="Arawaks" w="108px" h="32px"/>
    </Link></HStack>
    <IconButton aria-label={"Cerrar sesi\u00f3n"} onClick={logout} variant="ghost" rounded="full" color="gray.500" _hover={{ bg: "red.50", color: "brand.red" }}><FiLogOut/></IconButton>
  </HStack>;
}
